import type { Team } from '@domain/schemas/team.schema';

export const selectAssignableTeams = (teams: Team[], assignedIds: (string | number)[] = []) => {
  const assigned = new Set(assignedIds.map(String));

  return teams.filter(({ id, status }) => status !== 'Disabled' || assigned.has(String(id)));
};
